import { useEffect } from "react";

export function AccessibilityStatement() {
  const lastUpdated = "11/03/2026"; // ⬅️ עדכן לפני עלייה לאוויר
  const siteName = "אתר עו״ד ארז עזרא";
  const ownerName = "עו״ד ארז עזרא";
  const phone = "03-5563036";
  const email = "ezlaw.adv@gmail.com";
  const address = "פתח תקווה, ישראל";

  useEffect(() => {
    document.title = "הצהרת נגישות | עו״ד ארז עזרא";
  }, []);

  return (
    <main
      id="main"
      className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-black text-slate-200 pt-28 pb-20"
      aria-labelledby="a11y-title"
    >
      <nav aria-label="ניווט חזרה לאתר">
        <a
          href="/"
          aria-label="חזרה לדף הבית"
          className="fixed top-6 right-6 z-[9999] inline-flex items-center gap-2
                     px-5 py-2.5 rounded-full
                     bg-slate-900/80 backdrop-blur-md
                     border border-white/10
                     text-slate-200
                     shadow-lg
                     hover:bg-slate-800 transition-all
                     focus-visible:ring-2 focus-visible:ring-blue-600"
        >
          ← חזרה לאתר
        </a>
      </nav>
      <div className="container mx-auto px-6 max-w-3xl">
        <header className="mb-10">
          <h1
            id="a11y-title"
            className="text-4xl md:text-5xl font-bold tracking-tight mb-4"
          >
            הצהרת נגישות
          </h1>
          <p className="text-slate-400 text-lg leading-relaxed max-w-2xl">
            אנו ב-{siteName} משקיעים מאמצים רבים בהנגשת האתר, במטרה לאפשר שימוש
            נוח, ידידותי ושוויוני לכלל המשתמשים, לרבות אנשים עם מוגבלויות.
          </p>
        </header>

        <section aria-labelledby="a11y-standard" className="mb-12 max-w-2xl">
          <h2 id="a11y-standard" className="text-2xl font-bold mb-3">
            תקן נגישות
          </h2>
          <p className="text-slate-300 leading-relaxed">
            האתר שואף לעמוד בהנחיות הנגישות <strong>WCAG 2.1</strong> ברמה{" "}
            <strong>AA</strong>, ובהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות
            (התאמות נגישות לשירות), תשע"ג-2013.
          </p>
        </section>

        <section aria-labelledby="a11y-features" className="mb-12 max-w-2xl">
          <h2 id="a11y-features" className="text-2xl font-bold mb-3">
            התאמות נגישות שבוצעו באתר
          </h2>

          <ul className="list-disc pr-6 marker:text-slate-400 space-y-2 text-slate-300 leading-relaxed">
            <li>
              תמיכה בניווט מלא באמצעות מקלדת (Tab / Shift+Tab / Enter / Esc).
            </li>
            <li>תצוגת ניגודיות רגילה (כהה) ומצב ניגודיות גבוהה.</li>
            <li>אפשרות להפחתת אנימציות ותנועה (Reduce Motion).</li>
            <li>הדגשת קישורים והדגשת כותרות לשיפור זיהוי תוכן.</li>
            <li>גופן קריא ושינוי גודל טקסט.</li>
            <li>Skip to Content – דילוג לתוכן הראשי.</li>
            <li>מבנה סמנטי תקין (Landmarks/Headings) ותמיכה בקוראי מסך.</li>
            <li>מצבי Focus נראים וברורים (Focus Visible).</li>
          </ul>

          <p className="mt-4 text-slate-400 text-sm leading-relaxed">
            * ייתכן שחלק מההתאמות תלויות בדפדפן/מערכת הפעלה/טכנולוגיה מסייעת.
          </p>
        </section>

        <section aria-labelledby="a11y-limitations" className="mb-12 max-w-2xl">
          <h2 id="a11y-limitations" className="text-2xl font-bold mb-3">
            מגבלות ותכנים של צד ג׳
          </h2>
          <p className="text-slate-300 leading-relaxed">
            למרות מאמצינו להנגיש את כלל רכיבי האתר, ייתכן ותתקלו בחלקים שעדיין
            אינם מונגשים באופן מלא (לדוגמה רכיבי צד ג׳, הטמעות חיצוניות, או
            מסמכים שהועלו). אם נתקלתם בקושי – נשמח שתעדכנו אותנו ונפעל לתקן
            בהקדם האפשרי.
          </p>

          <p className="text-slate-300 leading-relaxed mt-4">
            אנו פועלים לשיפור מתמיד של נגישות האתר. למרות מאמצינו להנגיש את כלל
            חלקי האתר, ייתכן כי יימצאו חלקים או רכיבים שטרם הונגשו במלואם.
          </p>
        </section>

        <section aria-labelledby="a11y-tech" className="mb-12 max-w-2xl">
          <h2 id="a11y-tech" className="text-2xl font-bold mb-3">
            בדיקות תאימות
          </h2>
          <p className="text-slate-300 leading-relaxed">
            האתר נבדק בדפדפנים הנפוצים (Chrome, Safari, Edge) ובמערכות הפעלה
            נפוצות. כמו כן בוצעו בדיקות באמצעות ניווט מקלדת וקוראי מסך (כגון
            VoiceOver), במטרה להבטיח חוויית שימוש תקינה ונגישה. האתר מותאם
            לצפייה גם במכשירים ניידים כגון סמארטפונים וטאבלטים.
          </p>
        </section>

        <section aria-labelledby="a11y-contact" className="mb-12 max-w-2xl">
          <h2 id="a11y-contact" className="text-2xl font-bold mb-3">
            יצירת קשר בנושא נגישות
          </h2>

          <p className="text-slate-300 leading-relaxed mb-4">
            אם נתקלתם בבעיה, קושי, או שיש לכם הצעה לשיפור נגישות האתר – ניתן
            לפנות אלינו:
          </p>

          <p className="text-slate-300 leading-relaxed mb-6">
            אנו מתחייבים להשיב לפניות בנושא נגישות בתוך 7 ימי עסקים.
          </p>

          <p className="text-slate-300 leading-relaxed mb-4">
            בפנייה בנושא נגישות מומלץ לציין את תיאור הבעיה, הדף שבו נתקלתם
            בקושי, סוג הדפדפן והמכשיר שבו נעשה שימוש, וכן אמצעי יצירת קשר לצורך
            מענה.
          </p>

          <div className="rounded-2xl border border-white/10 bg-slate-900/60 backdrop-blur-md p-8 shadow-2xl shadow-black/40 space-y-3">
            <p className="text-slate-200">
              <strong>אחראי/ת נגישות:</strong> {ownerName}
            </p>
            <p className="text-slate-200">
              <strong>טלפון:</strong>{" "}
              <a
                className="text-blue-400 hover:text-blue-300 underline underline-offset-4"
                href={`tel:${phone.replace(/-/g, "")}`}
              >
                {phone}
              </a>
            </p>
            <p className="text-slate-200">
              <strong>דוא״ל:</strong>{" "}
              <a
                className="text-blue-400 hover:text-blue-300 underline underline-offset-4"
                href={`mailto:${email}`}
              >
                {email}
              </a>
            </p>
            <p className="text-slate-200">
              <strong>כתובת:</strong> {address}
            </p>
          </div>
        </section>

        <section aria-labelledby="a11y-updated" className="mb-12 max-w-2xl">
          <h2 id="a11y-updated" className="text-2xl font-bold mb-3">
            עדכון ההצהרה
          </h2>
          <p className="text-slate-300 leading-relaxed">
            הצהרת נגישות זו עודכנה בתאריך: <strong>{lastUpdated}</strong>.
          </p>
        </section>

        <hr className="border-white/10 my-12" />

        <section
          aria-labelledby="a11y-legal"
          className="text-sm text-slate-500 max-w-2xl"
        >
          <h2 id="a11y-legal" className="sr-only">
            הערה
          </h2>
          <p className="leading-relaxed">
            {siteName} פועל לשיפור מתמיד של חוויית הגלישה והנגישות באתר. נשמח
            לקבל משוב ולסייע בכל שאלה.
          </p>
        </section>
      </div>
    </main>
  );
}
